import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=0cb1bc4f&scoped=true&"
import script from "./InvoiceItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InvoiceItem.vue?vue&type=style&index=1&id=0cb1bc4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1bc4f",
  null
  
)

export default component.exports